import React from 'react';

const StaffLeaveSummary = () => {
  return (
    <div>
      <p>Leave Requests: 20</p>
      <p>Approved: 15</p>
      <p>Pending: 5</p>
    </div>
  );
};

export default StaffLeaveSummary;
